import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import type * as Types from './types';

export interface NotificationHoursSettingsStateProps {
    fetching: boolean;
    fetchingTimezones: boolean;
    updating: boolean;
    formData: Types.FormData;
    timezones?: Types.Option[];

    /**
     * Flag from the backend that determines whether we should show
     * the notification hours settings to the user.
     */
    show: boolean;
}
export class NotificationHoursSettingsState extends Record<NotificationHoursSettingsStateProps>({
    fetching: false,
    fetchingTimezones: false,
    updating: false,
    timezones: undefined,
    formData: {
        from: null,
        to: null,
        active: 'disabled',
        disableWeekends: false,
    },
    show: false,
}) {}

export default makeReducer<NotificationHoursSettingsState>(
    [
        match(Actions.fetchTimezones, state =>
            state.merge({
                fetchingTimezones: true,
            }),
        ),
        match(Actions.fetchTimezonesFailed, state =>
            state.merge({
                fetchingTimezones: false,
            }),
        ),
        match(Actions.fetchTimezonesSuccess, (state, {payload}) =>
            state.merge({
                fetchingTimezones: false,
                timezones: payload.timezones,
            }),
        ),
        match(
            Actions.fetch,
            () =>
                new NotificationHoursSettingsState({
                    fetching: true,
                }),
        ),
        match(Actions.fetchSuccess, (state, {payload}) => {
            return state.merge({
                fetching: false,
                formData: payload.formData,
                show: payload.show,
            });
        }),
        match(Actions.fetchFailed, state =>
            state.merge({
                fetching: false,
            }),
        ),
        match(Actions.update, state =>
            state.merge({
                updating: true,
            }),
        ),
        match(Actions.updateSuccess, (state, {payload}) =>
            state.merge({
                updating: false,
                formData: payload.formData,
            }),
        ),
        match(Actions.updateFailed, state =>
            state.merge({
                updating: false,
            }),
        ),
        match(Actions.updateAborted, state =>
            state.merge({
                updating: false,
            }),
        ),
    ],
    new NotificationHoursSettingsState(),
);
